import { a as h, j as t, F as x } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { Colors as e } from "../../1-foundations/Colors/Colors.js";
import "@ionic/react";
import { f as g, T as m, b as C } from "../../../FeatureFlagProvider-CQds873Z.js";
function D(i) {
  const {
    label: r,
    description: o = i.descriptionText,
    descriptionTextState: n = "primary",
    hasContainer: a = !1,
    isDisabled: s,
    isChecked: c,
    isReadOnly: l,
    hasInputField: p = !1,
    hasBorderBottom: u = !1,
    textAreaProps: b,
    onChange: d = i.onCheckedChange
  } = i, f = (k) => {
    !s && !l && (d == null || d(k.target.checked));
  };
  return /* @__PURE__ */ h("label", {
    css: {
      // Layout
      display: "flex",
      justifyContent: "flex-start",
      gap: 16,
      padding: "16px 24px",
      alignItems: "start",
      // Background & Hover
      transition: "background-color 200ms ease",
      backgroundColor: e.white200,
      ":hover": !s && !l ? {
        background: e.white300
      } : {},
      // Text
      ...C({
        color: s ? "slate300" : "black"
      }),
      // Border
      borderBottom: u ? `1px solid ${e.slate200}` : "none",
      cursor: s || l ? "not-allowed" : "pointer",
      // Border Emphasis
      ...a && {
        border: `1px solid ${e.blue500}`,
        borderRadius: 8
      }
    },
    children: [/* @__PURE__ */ t("input", {
      "data-testid": typeof r == "string" ? `checkbox-${r.toLowerCase().replace(/ /g, "-")}` : "checkbox",
      type: "checkbox",
      checked: c,
      onChange: f,
      disabled: s,
      readOnly: l,
      css: {
        opacity: 0,
        position: "absolute"
      }
    }), /* @__PURE__ */ t("div", {
      css: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "inherit",
        height: 24,
        width: 24,
        flexShrink: 0
      },
      children: /* @__PURE__ */ t(y, {
        ...i
      })
    }), /* @__PURE__ */ h("div", {
      css: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: [/* @__PURE__ */ h(x, {
        children: [r, o && /* @__PURE__ */ t("p", {
          css: {
            ...g({
              color: n === "secondary" ? "slate400" : "black"
            }),
            margin: 0
          },
          children: o
        })]
      }), p && c && b && /* @__PURE__ */ t("div", {
        css: {
          paddingTop: 16
        },
        children: /* @__PURE__ */ t(m, {
          ...b
        })
      })]
    })]
  });
}
function y(i) {
  const {
    isDisabled: r,
    isChecked: o,
    isReadOnly: n
  } = i, a = 18, s = r ? e.slate300 : n ? e.black : e.blue500, c = r ? o ? e.slate300 : e.white200 : o ? n ? e.black : e.blue500 : "transparent";
  return /* @__PURE__ */ t("svg", {
    viewBox: "0 0 24 24",
    css: {
      width: a,
      height: a,
      position: "relative",
      transition: "background 180ms cubic-bezier(0.4, 0, 0.2, 1)",
      borderRadius: `calc(${a}px * 0.125)`,
      border: `2px solid ${s}`,
      background: c,
      boxSizing: "border-box"
    },
    children: /* @__PURE__ */ t("path", {
      css: {
        fill: "none",
        stroke: e.white200,
        strokeWidth: "3",
        opacity: o ? "1" : "0",
        strokeDasharray: "30",
        strokeDashoffset: o ? "0" : "30",
        transition: "stroke-dashoffset 90ms linear 90ms"
      },
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    })
  });
}
export {
  D as CheckboxInput
};
